import { useForm, ValidationError } from "@formspree/react";
import "../styles/ContactUsForm.css";

export function ContactUsForm() {
  const [state, handleSubmit] = useForm("mdkgqydr");

  if (state.succeeded) {
    return (
      <p className="form-success-message">
        Thanks for emailing us! We'll get back to you shortly.
      </p>
    );
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-field">
        <label htmlFor="name">Full Name</label>
        <input id="name" name="name" type="text" required />
      </div>

      <div className="form-field">
        <label htmlFor="email">Email</label>
        <input id="email" name="email" type="email" required />
        <ValidationError
          prefix="Email"
          field="email"
          errors={state.errors}
          className="form-error"
        />
      </div>

      <div className="form-field">
        <label htmlFor="message">Message</label>
        <textarea id="message" name="message" rows="4" required />
        <p className="form-note">
          We usually respond within 1–2 business days.
        </p>
      </div>

      <div className="form-button-group">
        <button type="submit" disabled={state.submitting}>
          Send
        </button>
        <ValidationError errors={state.errors} />
      </div>
    </form>
  );
}
